export function addTimezoneAndAnalyticsTo(url: string): string {
  const newUrl = new URL(url, window.location.origin)
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (newUrl.searchParams.has('timezone')) {
    newUrl.searchParams.delete('timezone')
  }
  newUrl.searchParams.append('timezone', timezone)

  // EVENT ATTRIBUTION across frontend and backend Amplitude SDKs:
  // Add amplitude browser sdk's DeviceId and SessionId to URL params
  // so backend can use the same values for server side events:
  if (window.amplitude) {
    const deviceId = window.amplitude.getDeviceId()
    const sessionId = window.amplitude.getSessionId()
    if (deviceId) {
      newUrl.searchParams.append('amp_device_id', deviceId)
    }
    if (sessionId) {
      newUrl.searchParams.append('amp_session_id', sessionId)
    }
  }

  return newUrl.toString()
}
